import { Injectable } from '@angular/core';


@Injectable()
export class SearchFieldsControlInfoService {
  constructor() { }
  getSearchFieldsProperties() {

    const searchFieldsProperties: Array<any>[] =
      [
        [
          { key: 'siteType', type: 'dropdown', placeholder: 'Select Site Type', tooltip: 'Choose option to search all sites or only sites with Activity & Use Limitations.', label: "Site Type", width: 'col-md-6' },
          { key: 'townName', type: 'dropdownWithValueforCity', placeholder: 'Select City/Town', tooltip: 'The city and town where the release of oil or hazardous material occurred.', label: "City/Town", width: 'col-md-6' }
        ],
        [
          { key: 'rtn', type: 'text', placeholder: 'Select Release Tracking Number', tooltip: 'Release Tracking Number: Region # followed by unique 7 digit number.', label: "Release Tracking Number", pattern: "^[0-9]{1}[-]?[0-9]{7}$", errorMessage: "Use Format #-#######.", width: 'col-md-6' },
         // { key: 'rtn', type: 'dropdownWithValueforRTN', placeholder: 'Select Release Tracking Number', tooltip: 'Release Tracking Number: Region # followed by unique 7 digit number.', label: "Release Tracking Number",pattern: "^[0-9]{1}[-]?[0-9]{7}$", errorMessage: "Use Format #-#######.", width: 'col-md-6' },
          { key: 'zipCode', type: 'dropdownWithValue', placeholder: 'Select Zip Code', tooltip: 'Zip Code is not always accurate for pre-March 2024 RTNs.  The data is being updated.', label: "Zip Code", width: 'col-md-6' }
        ],
        [
          { key: 'chemical', type: 'dropdownWithValueforChemical', placeholder: 'Select Chemical Name', tooltip: 'List of Chemical details.', label: "Chemical", width: 'col-md-6' },
          { key: 'address', type: 'text', placeholder: 'Select Address', tooltip: 'The number and street that most accurately describe the site/release location.', label: "Address", width: 'col-md-6' }
        ],
        [
          { key: 'siteName', type: 'text', placeholder: 'Select Site Name', tooltip: 'Describes the site in terms of its location, use, or type.', label: "Site Name", width: 'col-md-6' },
          { key: 'lsp', type: 'dropdownWithValue', tooltip: "Licensed site professional on the release.", placeholder: 'Select Licensed Site Professional', label: "Licensed Site Professional", width: 'col-md-6' }
        ],
        [
          { key: 'regulatoryStatus', type: 'dropdown', tooltip: "Status of compliance within 21E.", placeholder: 'Select Regulatory Status', label: "Regulatory Status", width: 'col-md-6' },
          
         
        ]

      ]
    return searchFieldsProperties;
  }
}
